import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.product.barchart');
import { Input, OnChanges, OnDestroy, ElementRef } from '@angular/core';
import { Chart } from 'chart.js/auto';

interface ProductItem {
    grade: number;
    quantity: number;
    plate: number;
    weight: number;
    start: string;
    end: string;
}

@Component({
    selector: 'wiz-component-product-barchart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.product.barchart/view.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}`],
})
export class ComponentProductBarchartComponent implements OnChanges, OnDestroy {

    @Input() data: ProductItem[] | null = null;

    public display: any = {};
    public isEmpty: boolean = true;

    private chart?: Chart;

    private gradeMap = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

    constructor(@Inject( ElementRef) private el: ElementRef) {}

    ngOnDestroy() {
        this.chart?.destroy();
    }

    ngOnChanges() {
        if (!this.data?.length) {
            this.isEmpty = true;
            return;
        }

        this.isEmpty = false;

        let labels: string[] = [];
        let values: number[] = [];

        this.display.quantity = 0;
        this.display.plate = 0;
        this.display.weight = 0;

        for (const item of this.data) {
            labels.push(this.gradeMap[item.grade - 1]);
            values.push(item.quantity);

            this.display.start = item.start;
            this.display.end = item.end;

            this.display.quantity += item.quantity;
            this.display.plate += item.plate;
            this.display.weight += item.weight;
        }

        this.display.average_weight =
            this.display.quantity > 0
                ? this.display.weight / this.display.quantity * 1000
                : 0;

        setTimeout(() => {
            const canvas = this.el.nativeElement.querySelector('canvas') as HTMLCanvasElement;
            if (!canvas) return;

            this.chart?.destroy();

            this.chart = new Chart(canvas.getContext('2d')!, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [{
                        label: '생산수량',
                        data: values,
                        backgroundColor: '#1ba9e9'
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: { beginAtZero: true }
                    }
                }
            });
        }, 0);
    }
}

export default ComponentProductBarchartComponent;